<template>
  <div
    v-if="app"
    class="navbar-item has-dropdown"
    :class="{ 'is-active': active }"
    @click="active = !active"
  >
    <a class="navbar-link">
      {{ app.name }}
      <i class="material-icons">&#xE313;</i>
    </a>
    <div class="navbar-dropdown is-boxed is-center">
      <div class="navbar-items">
        <a
          v-for="appRecord in apps"
          @click.prevent="loadApp(appRecord.id)"
          :key="appRecord.id"
          :class="{ 'is-active': isActive(appRecord.id) }"
          class="navbar-item"
          >{{ appRecord.name }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { map } from 'lodash';
import router from 'router';
import Dropdown from 'views/mixins/dropdown';

export default {
  extends: Dropdown,

  computed: {
    apps() {
      return this.$store.state.application.apps;
    },

    app() {
      return this.$store.getters['application/app'];
    },
  },

  methods: {
    loadApp(id) {
      this.$store.dispatch('application/showApp', id);
    },

    isActive(id) {
      return router.currentRoute.path.startsWith(`/apps/${id}/`);
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar-item {
  justify-content: center;
}

.navbar-link,
.tag {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.25rem;
}
</style>
